import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';

function ProtectedRoute({ children, allowedRoles }) {
    const { user } = useContext(AuthContext);

    if (!user) {
        return <Navigate to="/" />; // Redirect to login if not authenticated
    }

    if (allowedRoles && user.Auth) {
        const userRole = user.Auth.toLowerCase();
        if (!allowedRoles.includes(userRole)) {
            return <Navigate to="/" />;
        }
    }

    return children;
}

export default ProtectedRoute;
